import { PERIOD_IDS } from "@iliotech/component-library";

export const MONTHLY_EXCLUDED_PERIODS = [
  PERIOD_IDS.THIRTY_DAYS,
  PERIOD_IDS.ONE_DAY,
  PERIOD_IDS.MTD,
];
